export default __webpack_public_path__ + "static/media/logo_ambev.e1e5cec9.png";